import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MODALS/MOVE_RULE_MODAL';

export const {action: show} = createAction(`${domain}/SHOW`, (institutionId, namespace, ruleGroups, rules, index) => ({
    institutionId,
    namespace,
    ruleGroups,
    rules,
    index,
}));

export const {action: hide} = createAction(`${domain}/HIDE`, data => ({data}));

export const {action: saveRules} = createAction(`${domain}/SAVE_RULES`, rules => ({rules}));
